import { ICommonSettings, IConfig } from "@kuika/kuika-cl-model";
import {
  CREATE_GLOBAL_CONFIG,
  GlobalConfigModuleActionTypes,
  SET_ACTIVE_GLOBAL_CONFIGURATION,
  SET_GLOBAL_CONFIGS,
  SET_GLOBAL_CONFIGS_LOADING_STATUS
} from "./types";

export const setGlobalConfigs = (
  globalConfigs: IConfig[],
  globalCommonSettings: ICommonSettings
): GlobalConfigModuleActionTypes => ({
  type: SET_GLOBAL_CONFIGS,
  meta: {
    params: {
      globalConfigs,
      globalCommonSettings
    }
  }
});

export const setActiveGlobalConfiguration = (
  activeGlobalConfiguration: IConfig | undefined = undefined
): GlobalConfigModuleActionTypes => ({
  type: SET_ACTIVE_GLOBAL_CONFIGURATION,
  meta: {
    params: {
      activeGlobalConfiguration
    }
  }
});

export const setGlobalConfigsLoadingStatus = (isGlobalConfigsLoading: boolean): GlobalConfigModuleActionTypes => ({
  type: SET_GLOBAL_CONFIGS_LOADING_STATUS,
  meta: {
    params: {
      isGlobalConfigsLoading
    }
  }
});

export const createGlobalConfig = (name: string): GlobalConfigModuleActionTypes => ({
  type: CREATE_GLOBAL_CONFIG,
  meta: {
    params: {
      name
    }
  }
});
